module.exports = __webpack_public_path__ + "img/classify_7.7882e19e.png";